import React from 'react'

function MerNone(props) {
  const Component = props.info.header
  return (
    <div >
      <Component>{props.info.question_text}</Component>
    </div>
  )
}

export default MerNone
